<template>
  <div>
    <!-- block -->
    <div class="block" v-if="download != null">
      <!-- File Type -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>File Type</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2 d-flex mr-5">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-autocomplete
              v-model="download.type"
              :items="driveTypeOptions"
              placeholder="請選擇File Type"
              item-text="title"
              item-value="value"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
          <div v-if="download.type === 2 || download.type === 4">
            <div class="w-248px">
              <v-text-field
                v-model="download.ver"
                placeholder="請輸入版本"
                outlined
                dense
              ></v-text-field>
            </div>
          </div>
        </div>
      </div>
      <!-- Bu -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>Bu</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-autocomplete
              v-model="download.bu_id"
              :items="buTabs"
              placeholder="請選擇所屬BU"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- Category -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>Category</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-autocomplete
              v-model="download.product_category_id"
              :items="categories"
              placeholder="請選擇所屬Category"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- SubCategory -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>SubCategory</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-autocomplete
              v-model="download.product_sub_category_id"
              :items="subcategories"
              placeholder="請選擇所屬SubCategory"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- Model Name -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>Model Name</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-autocomplete
              v-model="download.product_id"
              :items="products"
              placeholder="請選擇產品型號"
              item-text="model_name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- File Language -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>File Language</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-autocomplete
              v-model="download.language_id"
              :items="languages"
              placeholder="請選擇語言"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- Button Tag -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>按鈕標籤</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-autocomplete
              v-model="download.category"
              :items="tagOptions"
              placeholder="請選擇語言"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- File Name -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5"><h4>File Name</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <v-text-field
            v-model="download.name"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- File Format -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5"><h4>File Format</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <v-text-field
            v-model="download.format"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- File Descript -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5"><h4>File Descript</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <v-text-field
            v-model="download.description"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Update Date -->
      <div class="form-item d-flex pt-5">
        <div class="w-240px mr-5"><h4>Update Date</h4></div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="download.upload_date"
                  placeholder="請選擇日期"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="download.upload_date"
                @input="dateMenu = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
      <!-- Upload File -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Upload File</h4>
          <div class="h5 ink-02-medium--text">檔案大小限制：≤20MB</div>
        </div>
        <div class="flex-grow-1 flew-basis-0">
          <FileUploader
            v-model="download.path"
            :dir="'downloadfile'"></FileUploader>
        </div>
      </div>
      <!-- 圖片 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">圖片</h4>
          <div class="h5 ink-02-medium--text">
            此圖將顯示於下載中心 <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div>
          <ImgUploader
            :imageUrl.sync="download.image"
            dir="product"></ImgUploader>
        </div>
      </div>
      <!-- 刪除 -->
      <div class="form-item d-flex py-5" v-if="download.id">
        <div class="w-240px mr-5">
          <h4>刪除</h4>
        </div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <deleteDialog @confirm-delete="deleteHandler"></deleteDialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import FileUploader from '@/components/FileUploader.vue';
import deleteDialog from '@/components/ConfirmDelete.vue';

export default {
  components: {
    ImgUploader,
    FileUploader,
    deleteDialog,
  },
  data: () => ({
    fileType: '',
    categories: [],
    subcategories: [],
    products: [],
    dateMenu: false,
    fileName: '',
  }),
  computed: {
    ...mapState(['buTabs']),
    ...mapState('language', ['languages']),
    ...mapState('productDownload', ['download', 'driveTypeOptions', 'tagOptions']),
  },
  async created() {
    await this.getLanguages();
  },
  watch: {
    async 'download.bu_id'() {
      this.categories = await this.getCategories(this.download.bu_id);
    },
    async 'download.product_category_id'() {
      this.subcategories = await this.getSubCategories(this.download.product_category_id);
    },
    async 'download.product_sub_category_id'() {
      this.products = await this.getProducts(this.download.product_sub_category_id);
    },
    'download.type'(newValue) {
      if (newValue !== 2 && newValue !== 4) {
        this.download.ver = '';
      }
    },
  },
  methods: {
    ...mapActions('category', {
      getCategories: 'allByBu',
    }),
    ...mapActions('subcategory', {
      getSubCategories: 'allByCategory',
    }),
    ...mapActions('product', {
      getProducts: 'allBySubCateogry',
    }),
    ...mapActions('language', {
      getLanguages: 'find',
    }),
    ...mapActions('notifications', {
      error: 'error',
    }),
    ...mapActions('productDownload', {
      destroyDownload: 'destroy',
    }),
    deleteHandler() {
      const pThis = this;
      this.destroyDownload(this.download.id).then(() => {
        pThis.$router.push({ name: 'ProductDownload' });
      });
    },
  },
};
</script>

<style lang="scss">
.product-download-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}
</style>
